var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCommunitraders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 28,
    viewBox: "0 0 165 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-communitraders"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1411 0H0.5V10.6411H11.1411V0Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.5 0H17.8589V10.6411H28.5V0Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.1411 17.3589H0.5V28H11.1411V17.3589Z",
    fill: "#660000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.5 17.3589H17.8589V28H28.5V17.3589Z",
    fill: "#990000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M71.8282 5.88106C71.8282 10.2106 68.3515 11.7784 65.0942 11.7784C61.8369 11.7784 58.344 10.2106 58.344 5.88106C58.344 1.55149 61.8288 0 65.0942 0C68.3597 0 71.8282 1.56774 71.8282 5.88106ZM69.1801 5.88106C69.1801 3.6716 67.9048 1.97389 65.0942 1.97389C62.2837 1.97389 61.0083 3.6716 61.0083 5.88106C61.0083 8.09052 62.2837 9.80447 65.0942 9.80447C67.9048 9.80447 69.1801 8.10676 69.1801 5.88106Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M91.2015 0.227417V11.5346H88.6022V2.59934L84.8087 11.5346H82.3393L78.5459 2.59934V11.5346H75.9465V0.227417H79.9999L83.5659 8.91903L87.1482 0.227417H91.2015Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M112.159 0.227417V11.5346H109.559V2.59934L105.766 11.5346H103.297L99.5032 2.59934V11.5346H96.9038V0.227417H100.957L104.523 8.91903L108.105 0.227417H112.159Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M127.95 0.227417V6.96139C127.95 10.9173 125.399 11.7783 122.28 11.7783C119.161 11.7783 116.61 10.9254 116.61 6.96139V1.60833L119.21 0.227417V6.79893C119.21 9.10586 120.339 9.80444 122.28 9.80444C124.222 9.80444 125.351 9.11399 125.351 6.79893V1.60833L127.95 0.227417Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M145.504 0.227417V11.5346H142.58L136.309 3.46037V11.5346H133.709V0.227417H136.617L142.888 8.31793V0.227417H145.504Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M155.073 0.227417V11.5346H152.473V1.60833L155.073 0.227417Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M67.7666 27.6507L65.2972 23.6948H61.0408V27.6507H58.3521V15.9617H65.5653C68.7414 15.9617 70.3741 17.4807 70.3741 19.8363C70.3741 21.6721 69.5049 22.7769 67.9697 23.313L70.7559 27.6588H67.7666V27.6507ZM61.0326 21.6559H65.4597C67.1005 21.6559 67.6285 20.803 67.6285 19.8363C67.6285 18.8697 67.1249 18.033 65.4597 18.033H61.0326V21.6559Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M86.2058 25.3682H79.7886L78.7895 27.6589H75.9302L81.3401 15.9698H84.6462L90.0398 27.6589H87.1805L86.1977 25.3682H86.2058ZM85.3041 23.313L82.9972 18.0006L80.6903 23.313H85.3041Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M109.259 21.8103C109.259 26.4729 105.855 27.6589 102.208 27.6589H96.8958V15.9698H102.208C105.847 15.9698 109.259 17.1558 109.259 21.8184V21.8103ZM106.505 21.8103C106.505 18.8048 104.734 18.0331 101.948 18.0331H99.6088V25.5794H101.948C104.734 25.5794 106.505 24.8239 106.505 21.8022V21.8103Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M143.14 27.6507L140.671 23.6948H136.414V27.6507H133.725V15.9617H140.939C144.115 15.9617 145.747 17.4807 145.747 19.8363C145.747 21.6721 144.878 22.7769 143.343 23.313L146.129 27.6588H143.14V27.6507ZM136.406 21.6559H140.833C142.474 21.6559 143.002 20.803 143.002 19.8363C143.002 18.8697 142.498 18.033 140.833 18.033H136.406V21.6559Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M127.373 27.7969H116.659V15.783H127.203L126.098 17.9112H119.429V20.5755H126.723L125.619 22.6875H119.429V25.6768H126.268L127.373 27.805V27.7969Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M53.0151 17.9274H48.4662V27.8131H45.7044V17.9274H41.1555L42.2602 15.7992H53.0151V17.9274Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M47.8165 9.80447C45.1035 9.80447 44.0556 8.07427 44.0556 5.88106C44.0556 3.68785 45.1035 1.97389 47.8165 1.97389C49.1487 1.97389 50.026 2.38816 50.6027 3.01364H53.6001C52.5198 0.893531 50.1885 0 47.8084 0C44.543 0 41.375 1.63272 41.375 5.88106C41.375 10.1294 44.543 11.7784 47.8084 11.7784C50.1885 11.7784 52.5116 10.8848 53.6001 8.76472H50.6027C50.026 9.3902 49.1487 9.80447 47.8165 9.80447Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M159.419 20.6894C157.363 20.405 155.43 20.3401 155.43 19.2353C155.43 18.4312 155.999 17.7813 158.403 17.7813C160.539 17.7813 161.514 18.5205 161.62 19.3491L163.959 18.1144C163.35 16.6928 161.677 15.7262 158.436 15.7262C154.147 15.7262 152.839 17.497 152.839 19.414C152.839 21.3311 153.838 22.2165 157.03 22.7526C160.223 23.2887 162.026 23.1669 162.026 24.3691C162.026 25.2545 161.092 25.8393 158.866 25.8393C156.64 25.8393 155.341 25.222 155.276 24.0035L152.75 25.3601C153.44 26.9359 155.43 27.8945 158.639 27.8945C162.798 27.8945 164.885 26.5379 164.885 24.0035C164.885 21.4692 162.643 21.128 159.427 20.6812L159.419 20.6894Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M15.2838 5.22314H11.1411V6.17354H15.2838V5.22314Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M14.7559 7.49754L17.8751 5.69423L14.7559 3.89905V7.49754Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M23.6506 10.6331H22.7002V14.7758H23.6506V10.6331Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M21.3762 14.2478L23.1795 17.367L24.9747 14.2478H21.3762Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M17.8671 22.2002H13.7244V23.1506H17.8671V22.2002Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M14.2523 20.8761L11.1331 22.6794L14.2523 24.4746V20.8761Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M6.29976 13.2242H5.34937V17.367H6.29976V13.2242Z",
    fill: "#15202A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M7.62388 13.7523L5.82058 10.6331L4.02539 13.7523H7.62388Z",
    fill: "#15202A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCommunitraders);
export default __webpack_public_path__ + "static/media/Logo-communitraders.677364197ec94d17959298158dbd488e.svg";
export { ForwardRef as ReactComponent };